import React, { useState } from 'react';
import Carousel from 'react-spring-3d-carousel';
import { v4 as uuidv4 } from 'uuid';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import './CarouselComponent.css';
import logsUserService from '../../services/LogsUserActionService';
import { useAuth } from '../../context/AuthContext';

// Componente Card
const Card = ({ image, description, title, onClick }) => {
  return (
    <div className="card flex flex-col justify-between border-grueso cursor-pointer sm:mt-0 md:mt-0 lg:mt-5 xl:mt-5 bg-grayscale"
    style={{ width: "350px", height: "300px", border: "1px solid #ccc", borderRadius: "20px", overflow: "hidden", textAlign: "center", 
      backgroundImage: 'url(/images/background/Background-slides.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}
    onClick={onClick}>
      <img
        className='relative'
        src={image}
        alt={title}
        style={{ width: "30%", height: "auto", margin: "35px auto", marginBottom: '-3px' }}
      />
      <div className="card-content flex flex-col justify-between relative" style={{ padding: "15px", flexGrow: 1 }}>
        <p className="text-event-card">
          <span className="ApisBold text-xl text-white">{title}:</span>
          <br />
          <span className="text-carousel text-sm text-white ApisRegular"> {description}.</span>
        </p>
      </div>
    </div>
  );
};

// Componente CarouselPhotos
const CarouselPhotos = (props) => {
  const navigate = useNavigate();
  const [goToSlide, setGoToSlide] = useState(0);
  const [offsetRadius, setOffsetRadius] = useState(2);
  const [config, setConfig] = useState({});
  const { token, idUser } = useAuth();

  const getSlides = () => {
    const goToEventInfo = (idEvent, eventName) => {
      navigate(`/eventos/${idEvent}`);
      logsUserService(idUser, `Clic en la tarjeta del evento ${eventName}`, token);
    };

    return props.slides.map((slide) => ({
      key: uuidv4(),
      content: (
        <Card
          title={slide.name}
          description={slide.description}
          image={slide.picture}
          onClick={() => goToEventInfo(slide.id, slide.name)}
        />
      ),
    }));
  };

  const offsetFn2 = () => ({
    opacity: 1
  });

  const slides = getSlides();

  return (
    <>
      {/* Vista PC */}
      <div className="hidden lg:flex w-full mx-auto items-center justify-between" style={{ width: "100%", height: "300px" }}>
        <button className="nav left buttons-carousel mr-2 md:mr-5" onClick={() => setGoToSlide(goToSlide - 1)}>
          <FaAngleLeft className="text-4xl size-arrow" />
        </button>
        <Carousel
          slides={slides}
          goToSlide={goToSlide}
          offsetRadius={offsetRadius}
          showNavigation={false}
          animationConfig={config}
        />
        <button className="nav right ml-2 md:ml-4" onClick={() => setGoToSlide(goToSlide + 1)}>
          <FaAngleRight className="text-4xl size-arrow" />
        </button>
      </div>

      {/* Vista Tablet */}
      <div className="hidden md:flex lg:hidden w-full mx-auto items-center justify-between" style={{ width: "100%", height: "400px" }}>
        <button className="nav left mr-5 md:mr-5" onClick={() => setGoToSlide(goToSlide - 1)}>
          <FaAngleLeft className="text-5xl size-arrow" />
        </button>
        <Carousel
          slides={slides}
          goToSlide={goToSlide}
          offsetRadius={offsetRadius}
          showNavigation={false}
          animationConfig={config}
          offsetFn={offsetFn2}
        />
        <button className="nav right ml-2 md:ml-5" onClick={() => setGoToSlide(goToSlide + 1)}>
          <FaAngleRight className="text-5xl size-arrow" />
        </button>
      </div>

      {/* Vista Móvil */}
      <div className="flex md:hidden w-full mx-auto items-center justify-between" style={{ width: "40%", height: "300px" }}>
        <Carousel
          slides={slides}
          goToSlide={goToSlide}
          offsetRadius={offsetRadius}
          showNavigation={false}
          animationConfig={config}
          offsetFn={offsetFn2}
        />
      </div>

      <div className="flex md:hidden lg:hidden justify-center w-full mt-4">
        <button className="nav left mr-5" onClick={() => setGoToSlide(goToSlide - 1)}>
          <FaAngleLeft className="text-5xl size-arrow" />
        </button>
        <button className="nav right ml-5" onClick={() => setGoToSlide(goToSlide + 1)}>
          <FaAngleRight className="text-5xl size-arrow" />
        </button>
      </div>
    </>
  );
};

export default CarouselPhotos;
